import { AxiosError } from "axios";
import { useContacts } from "hooks/useContacts";
import { useCount } from "hooks/utils/useCount";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { Contact } from "types/Contact";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

type OnlyTransferContactMutationProps = {
  contactId: string;
  departmentId: string;
}

async function onlyTransferContact(contactId: string, departmentId: string): Promise<Contact> {
  const { data: transferredContact } = await api.post(`/contacts/${contactId}/category/${departmentId}`)
    .then(axiosSuccess)
    .catch(axiosError);
  return transferredContact;
}

export function useOnlyTransferContact() {
  const { selectContact } = useContacts();
  const { revalidateCount } = useCount();

  const queryClient = useQueryClient();

  return useMutation(({ contactId, departmentId }: OnlyTransferContactMutationProps) => onlyTransferContact(contactId, departmentId), {
    onSuccess: (data: Contact) => {
      handleRequestSuccess(`Contato transferido com sucesso!`);
      queryClient.invalidateQueries('messages');
      selectContact(data);
      revalidateCount();
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Um erro ocorreu ao transferir este contato. Por favor, tente novamente!');
    }
  });
}
